module.exports = __webpack_public_path__ + "img/ml3056.edf82fc3.png";